import React from "react"
import { Route } from "react-router-dom"
import "./styles.scss"

import SignIn from "./scenes/SignIn"
import SignUp from "./scenes/SignUp"
import ResetPassword from "./scenes/ResetPassword"
import ForgotPassword from "./scenes/ForgotPassword"
import VerifyEmail from "./scenes/VerifyEmail"
import SignUpGuardian from "./scenes/SignUpGuardian"

const Authentication = () => {
  return (
    <div className="authentication">
      <Route exact path="/sign-up" component={SignUp} />
      <Route exact path="/sign-up/guardian/:token" component={SignUpGuardian} />
      <Route path="/sign-in" component={SignIn} />
      <Route path="/reset-password/:email/:code" component={ResetPassword} />
      <Route path="/forgot-password" component={ForgotPassword} />
      <Route path="/verify-email/:code" component={VerifyEmail} />
    </div>
  )
}

export default Authentication
